import { MLSStatus } from 'features/valueObjects/MLSStatus'

const ACTIVE_MLS_STATUSES: MLSStatus[] = [
  'FOR_SALE',
  'FOR_LEASE',
  'SALE_OR_LEASE',
  'PENDING',
]

export const getPreviewMLSStatus = (status: MLSStatus): MLSStatus =>
  ACTIVE_MLS_STATUSES.includes(status)
    ? status
    : 'OFF_MARKET'
